let list = []
for (let index = 0; index < 100; index++) {
    list.push({
        id: "photo-"+index,
        title: "Photo " + index,
        photographe: "toto",
        annee: "1929",

    })
}

export const getRandom = () =>
    list[Math.floor(Math.random()*list.length)]

export const search = layout => {
    return list.filter(item => {
        if (layout.title && item.title.toLowerCase().indexOf(layout.title.toLowerCase()) !== -1) {
            return true;
        }

        return false;
    })
}

export default list;